// eslint-disable-next-line
const style = (theme, scale = 1) => {
  return {
    nav: {
      "&.MuiGrid2-root": {
        position: "relative",
        marginTop: { xs: "24px", md: "34px" },
        marginBottom: { xs: "20px", md: "26px" },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "0px 0px 0px 0px ",
      },
      mobile: {
        "&.MuiGrid2-root": {
          position: "relative",
          marginTop: "22px",
          marginBottom: "18px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "0px 0px 0px 0px ",
        },
      },
    },

    homeContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      width: "100%",
      padding: { xs: "0 16px", md: "0 28px" },
    },
    contentViewport: {
      width: "100%",
      position: "relative",
      isolation: "isolate",
    },
    modePanel: {
      width: "100%",
      position: "relative",
      zIndex: 1,
    },
    testnetFunding: {
      width: "100%",
      margin: "0 auto 18px",
      padding: "18px 22px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexDirection: "row",
      gap: "24px",
      color: "var(--tezex-text)",
      background: "var(--tezex-panel-subtle)",
      border: "1px solid var(--tezex-line)",
      borderRadius: "20px",
      textAlign: "left",
      "@media (max-width: 599px)": {
        padding: "16px 22px",
        alignItems: "stretch",
        flexDirection: "column",
        gap: "15px",
        borderRadius: "18px",
      },
    },
    testnetFundingCopy: {
      minWidth: 0,
      textAlign: "left",
    },
    testnetFundingEyebrow: {
      color: "var(--tezex-muted)",
      fontSize: "9px",
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: "0.18em",
    },
    testnetFundingTitle: {
      marginTop: "5px",
      color: "var(--tezex-text-secondary)",
      fontSize: { xs: "15px", sm: "16px" },
      fontWeight: 650,
      lineHeight: 1.3,
    },
    testnetFundingMessage: {
      maxWidth: "520px",
      marginTop: "5px",
      color: "var(--tezex-muted)",
      fontSize: "11px",
      lineHeight: 1.55,
    },
    testnetFundingActions: {
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      gap: "8px",
      "@media (max-width: 599px)": {
        display: "grid",
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      },
    },
    testnetFundingPrimary: {
      minHeight: "38px",
      padding: "9px 14px",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      color: "var(--tezex-action-text)",
      background: "var(--tezex-action)",
      border: "1px solid var(--tezex-action)",
      borderRadius: "999px",
      fontSize: "9px",
      fontWeight: 700,
      lineHeight: 1.35,
      letterSpacing: "0.1em",
      textAlign: "center",
      textDecoration: "none",
      whiteSpace: "nowrap",
      "& svg": {
        width: "13px",
        height: "13px",
        flex: "0 0 13px",
      },
      "&:hover": {
        color: "var(--tezex-action-text)",
        background: "var(--tezex-action-hover)",
        textDecoration: "none",
      },
    },
    testnetFundingSecondary: {
      minHeight: "38px",
      padding: "9px 14px",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      color: "var(--tezex-text-secondary)",
      background: "transparent",
      border: "1px solid var(--tezex-line-strong)",
      borderRadius: "999px",
      fontSize: "9px",
      fontWeight: 700,
      lineHeight: 1.35,
      letterSpacing: "0.1em",
      textAlign: "center",
      textDecoration: "none",
      whiteSpace: "nowrap",
      "& svg": {
        width: "13px",
        height: "13px",
        flex: "0 0 13px",
      },
      "&:hover": {
        color: "var(--tezex-text)",
        background: "var(--tezex-hover)",
        textDecoration: "none",
      },
    },
    networkNotice: {
      width: "100%",
      maxWidth: "720px",
      margin: "0 auto",
      color: "text.primary",
      backgroundColor: "background.paper",
      border: "1px solid",
      borderColor: "divider",
      borderRadius: { xs: "28px", md: "32px" },
      boxShadow: "none",
    },
    networkNoticeContent: {
      padding: { xs: "32px 28px", md: "44px 48px" },
      "&:last-child": { paddingBottom: { xs: "32px", md: "44px" } },
    },
    networkNoticeEyebrow: {
      color: "text.secondary",
      fontSize: "12px",
      fontWeight: 700,
      letterSpacing: "0.18em",
      textTransform: "uppercase",
      marginBottom: "12px",
    },
    networkNoticeTitle: {
      fontSize: { xs: "26px", md: "32px" },
      fontWeight: 650,
      lineHeight: 1.15,
      letterSpacing: "-0.02em",
      marginBottom: "14px",
    },
    networkNoticeMessage: {
      color: "text.secondary",
      fontSize: { xs: "16px", md: "17px" },
      lineHeight: 1.55,
      maxWidth: "620px",
    },
    networkNoticeActions: {
      display: "flex",
      alignItems: { xs: "stretch", sm: "center" },
      flexDirection: { xs: "column", sm: "row" },
      gap: { xs: "14px", sm: "20px" },
      marginTop: { xs: "28px", md: "34px" },
    },
    networkNoticeButton: {
      minHeight: "48px",
      padding: "0 24px",
      borderRadius: "999px",
      backgroundColor: "text.primary",
      color: "background.paper",
      boxShadow: "none",
      textTransform: "none",
      fontSize: "15px",
      fontWeight: 650,
      "&:hover": {
        backgroundColor: "text.primary",
        boxShadow: "none",
      },
    },
    networkNoticeLink: {
      color: "text.primary",
      fontSize: "15px",
      fontWeight: 600,
      textAlign: "center",
      textUnderlineOffset: "4px",
    },
  };
};

export default style;
